<template>
  <div style="margin-bottom:20px">
    <LineChartGenerator
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
import { formularioService, globales } from '@/services';
import { utils } from '@/helpers';
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import {Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, PointElement, TimeScale} from 'chart.js'
import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";
import 'chartjs-adapter-moment';

ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, PointElement, ChartJSPluginDatalabels, TimeScale)

export default {
  components: { LineChartGenerator },
  props: {
    data: {},
    titulo: {
      type: String, 
      default: ''
    },
    chartId: {
      type: String,
      default: 'linea-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return {
      globales,
      loading: true,
      chartData: {
        labels: this.data != null ? this.data.categoria : [],
        datasets: this.data != null ? this.formatearData(this.data.data) : []
      },
      chartOptions: {
        scales: {
          x:{
            type: 'time',
            time: {
              displayFormats: {
                'millisecond': 'DD-MM-YYYY',
                'second': 'DD-MM-YYYY HH:mm',
                'minute': 'DD-MM-YYYY HH:mm',
                'hour': 'DD-MM-YYYY HH:mm',
                'day': 'DD-MM-YYYY HH:mm',
                'week': 'DD-MM-YYYY HH:mm',
                'month': 'DD-MM-YYYY HH:mm',
                'quarter': 'DD-MM-YYYY HH:mm',
                'year': 'DD-MM-YYYY HH:mm',
              },
              parser: 'YYYY-MM-DD HH:mm:ss',
              tooltipFormat: 'DD/MM/yyyy HH:mm',
              unitStepSize: 1,
            }
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: this.titulo == '' ? 'Grafico de ejemplo': this.titulo
          },
          datalabels: {
            backgroundColor: function(context) {
              return context.dataset.backgroundColor;
            },
            borderColor: 'white',
            borderRadius: 25,
            borderWidth: 2,
            color: 'white',
            font: {
              weight: 'bold'
            },
            display: function(context) {
              var dataset = context.dataset;
              var value = dataset.data[context.dataIndex];
              return value > 0;
            },
          }
        },
      }
    }
  },
  watch:{
    data(){
      this.chartData = {
        labels: this.data != null ? this.data.categoria : [],
        datasets: this.data != null ? this.formatearData(this.data.data) : []
      }
    },
    titulo(){
      this.chartOptions.plugins.title.text = this.titulo == '' ? 'Grafico de ejemplo': this.titulo;
    }
  },
  methods : {
    formatearData(data){
      data.forEach((element)=> {
        element.label = element.name;
        let dynamicColors = function() {
          var r = Math.floor(Math.random() * 255);
          var g = Math.floor(Math.random() * 255);
          var b = Math.floor(Math.random() * 255);
          return "rgb(" + r + "," + g + "," + b + ")";
        };
        element.backgroundColor = dynamicColors();
      });
      return data;
    },
    cargarDatos(){
      this.loading = true;

      formularioService.getGraficoHistorialFormulario({
        id_usuario: this.$store.state.usuario.id_usuario,
        id_nodo: this.$store.state.usuario.usa_organizacion == 'S' ? this.filtro.id_nodo.split(",") : null,
        perfiles: utils.mapAtributo(this.$store.state.usuario.perfiles, 'id_perfil'), 
        id_sucursal: utils.mapAtributo(this.$store.state.usuario.sucursales, 'id_sucursal'),
        id_categoria: utils.mapAtributo(this.$store.state.usuario.categorias,'id_categoria'),
        fecha_i: utils.DateToFecha(this.filtro.fecha_i, 'dd-mm-yyyy'),
        fecha_t: utils.DateToFecha(this.filtro.fecha_t, 'dd-mm-yyyy'),
        tipo_ejecutor:[0,2] 
      }).then(data => {
        this.chartData.labels = [];
        this.chartData.datasets = [{
          backgroundColor: ['#f8ac59'],
          data: [],
          label: 'Realizados'
        },
        {
          backgroundColor: ['#1E90FF'],
          data: [],
          label: 'Asignadas'
        },
        {
          backgroundColor: ['#4CAF50'],
          data: [],
          label: 'Terminadas'
        }];

        if(data.status == 'success'){
          data.data.forEach((element)=>{
            this.chartData.datasets[0].data.push({x:element.fecha, y:element.r});
            this.chartData.datasets[1].data.push({x:element.fecha, y:element.e});
            this.chartData.datasets[2].data.push({x:element.fecha, y:element.t});
          });
        }

        this.loading = false;
      });
    },
  }
}
</script>

<style scoped>
</style>
